export default __webpack_public_path__ + "static/media/a1.a8175b30.png";